// Felles for «Servicer på verkstedet» (/verkstedet og /verkstedet/:id): en forenklet,
// informasjonsside for butikkansatte ved siden av Servicelisten (WorkshopList) og
// WorkshopDetails, som ikke endres. Se planer/ny-kundesamhandling-plan.md.
//
// Servicene hentes med GET /workshop-services (samme som Servicelisten), ikke med
// GET /workshop-services/:id: den markerer et betalingsvarsel som sett når servicen åpnes,
// og det skal bare skje når mekanikeren åpner den i WorkshopDetails.
import Cookies from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const LUKKET = ['avsluttet', 'kansellert'];

export const STATUS_NAVN = {
  mottatt: 'Mottatt',
  innlevert: 'Innlevert',
  aktiv: 'Under arbeid',
  'venter på deler': 'Venter på deler',
  pristilbud: 'Pristilbud sendt',
  'venter på godkjenning': 'Venter på svar fra kunden',
  godkjent: 'Godkjent av kunden',
  avsluttet: 'Ferdig',
  kansellert: 'Kansellert',
};

export const statusNavn = (s) => {
  const k = String(s || '').toLowerCase();
  return STATUS_NAVN[k] || (k ? k.charAt(0).toUpperCase() + k.slice(1) : 'Ukjent');
};

export const STATUS_FARGE = {
  mottatt: 'bg-sky-100 text-sky-900',
  innlevert: 'bg-sky-100 text-sky-900',
  aktiv: 'bg-emerald-100 text-emerald-900',
  'venter på deler': 'bg-amber-100 text-amber-900',
  pristilbud: 'bg-violet-100 text-violet-900',
  'venter på godkjenning': 'bg-violet-100 text-violet-900',
  godkjent: 'bg-emerald-100 text-emerald-900',
  avsluttet: 'bg-slate-200 text-slate-800',
  kansellert: 'bg-slate-200 text-slate-800',
};

// Samme butikkgjenkjenning som Servicelisten (WorkshopList: resolveStoreLabel).
export function butikkFor(s) {
  const kandidater = [
    s?.produkt?.butikk, s?.produkt?.verksted, s?.produkt?.butikkSlug, s?.produkt?.verkstedSlug,
    s?.butikk, s?.verksted, s?.butikkSlug, s?.verkstedSlug,
  ];
  for (const v of kandidater) {
    const low = String(v || '').trim().toLowerCase();
    if (!low) continue;
    if (low.includes('røyken') || low.includes('royken')) return 'Røyken';
    if (low.includes('slemmestad')) return 'Slemmestad';
  }
  return '';
}

// Butikken den ansatte er logget inn i (som Servicelisten).
export function valgtButikk() {
  const id = Cookies.get('butikkid') || '';
  if (id === '1') return 'Røyken';
  if (id === '2') return 'Slemmestad';
  const navn = (Cookies.get('selectedStore') || '').toLowerCase();
  if (navn.includes('slemmestad')) return 'Slemmestad';
  if (navn.includes('røyken') || navn.includes('royken')) return 'Røyken';
  return '';
}

// Datoen kunden er lovet, som i Servicelisten: beregnet ferdigdato, men for ski gjelder ønsket
// ferdigdato hvis den er tidligere (ansatt-overstyring).
export function ferdigDato(s) {
  const beregnet = s?.produkt?.forventetFerdigDato || s?.forventetFerdigDato || null;
  const onsket = (s?.produkt?.ferdigDatoValgfri && s?.produkt?.onsketFerdigDato) || null;
  const valgt = onsket && (!beregnet || new Date(onsket) < new Date(beregnet)) ? onsket : beregnet;
  const d = valgt ? new Date(valgt) : null;
  return d && !isNaN(d) ? d : null;
}

export function leveringsDato(s) {
  const v = s?.produkt?.leveringsDato || s?.leveringsDato || null;
  const d = v ? new Date(v) : null;
  return d && !isNaN(d) ? d : null;
}

export const kundeNavn = (s) =>
  [s?.customerSnapshot?.firstName, s?.customerSnapshot?.lastName].filter(Boolean).join(' ');

export const produktTekst = (s) =>
  [s?.produkt?.produktmerke || s?.produkt?.navn, s?.produkt?.produkttype, s?.produkt?.farge && `(${s.produkt.farge})`]
    .filter(Boolean)
    .join(' ') || 'Produkt';

const startPaDagen = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
export const dagerTil = (d) => Math.round((startPaDagen(d) - startPaDagen(new Date())) / 86400000);

// «i dag», «i morgen», «i går» eller «tor. 29.10.»
export function narTekst(d) {
  if (!d) return '';
  const n = dagerTil(d);
  if (n === 0) return 'i dag';
  if (n === 1) return 'i morgen';
  if (n === -1) return 'i går';
  return d.toLocaleDateString('nb-NO', { weekday: 'short', day: 'numeric', month: 'numeric' });
}

export async function hentServicer() {
  const r = await fetch(`${API_BASE_URL}/workshop-services`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const data = await r.json();
  return Array.isArray(data) ? data : [];
}

// Lagrer bare kommentaren (samme rute som «Endre produktinfo» i WorkshopDetails).
export async function lagreKommentar(id, kommentar) {
  const r = await fetch(`${API_BASE_URL}/workshop-services/${id}/product-comment`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ kommentar }),
  });
  const data = await r.json().catch(() => null);
  if (!r.ok) throw new Error(data?.message || 'Kunne ikke lagre kommentaren');
  return data;
}
